import { css } from '@emotion/react';

const getTablePaginatorCss = css`
  border-bottom-left-radius: var(--cds-border-radius-200);
  border-bottom-right-radius: var(--cds-border-radius-200);
  border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  border-top: none;
  padding: var(--cds-spacing-200) var(--cds-spacing-300);
`;

export default getTablePaginatorCss;
